module.exports = __webpack_public_path__ + "img/DichKriegenWirAuchNoch.e9d19cb8.svg";